import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import CareerSeeker from 'wwg-utilities/dist/collections/career-seeker';
import { useAuth } from '../../providers/authProvider';
import gaDataLayerEvent from './gaDataLayerEvent';

const useGAPageLoad = (serverSeeker: CareerSeeker | null) => {
  const { seeker } = useAuth();
  const { asPath } = useRouter();
  const prevRoute = useRef('');
  const serverSeekerRef = useRef(serverSeeker);
  const { query } = useRouter();
  const region = query[':region'];
  if (typeof window != 'undefined') {
    useEffect(() => {
      gaDataLayerEvent({
        event: 'page_view',
        user_id: seeker?.id || serverSeekerRef.current?.id || 'null',
        logged_in_status:
          seeker || serverSeekerRef.current?.id ? 'Logged In' : 'Logged Out',
        filter: {
          location: region,
        },
      });
      prevRoute.current = asPath;
      serverSeekerRef.current = null;
      return () => {};
    }, [window, asPath]);
  }
};

export default useGAPageLoad;
